<template lang="pug">
	div(v-if="ready")
		b-modal(id="forgot-password-modal" ref="forgotPasswordModal" title="Reset Password" @hidden="closeModal" @shown="focusEmail" no-fade centered :hide-footer="true")
			span(v-if="!showSuccess")
				p
					| Enter your e-mail address to begin the reset password process.
				p Once entered, we will send a key to the e-mail address you specified. If you use a mail filtering tool make sure you allow email from support@savingforcollege.com prior to submitting the request.
				.alert.alert-danger(v-if="generalLoginErrorExist")
					p
						sfc-html-evaluator(:content=`generalLoginErrorMessage`)
				br
				form(v-on:submit.prevent="forgotPassword")
					.tb
						label(:class="{'not-empty': !email == '' }")
							b-form-input.input(ref="email" type="text" :class="{error: userEmailErrorExist}" v-model="email" @input="validResetPasswordForm")
							span.floaty-label
								| Email
							span.error(v-if="userEmailErrorExist")
								| &nbsp;{{userEmailErrorMessage}}
					br
					b-btn.button.sfc-blue(type="submit")
						| RESET MY PASSWORD
					p.text-center
						| Nevermind.&nbsp;
						a(@click="closeModal()")
							| Go Back
			span(v-else)
				p
					| Reset password email successfully sent.
				p
					| Please check your inbox.
				a(@click="finishModal")
					| close

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#forgot-password-modal
		a.forgot-pw
			display: block
			text-align: right
		.button.sfc-blue
			width: 100%
			max-width: 300px
			margin: 15px auto
			display: block
		.modal-header
			button.close
				color: #fff!important

	.input
		font-size: body-font-size
		@media (max-width: 575px)
			font-size: body-font-size-md

</style>

<script>
	export default {
		data(){
			return {
				ready: true,
				email:"",
				validateLoginOnChange: false,
				generalLoginErrorMessage: "",
				generalLoginErrorExist: false,
				userEmailErrorMessage: "",
				userEmailErrorExist: false,
				loadingLogin: false,
				showSuccess: false
			}
		},

		methods:{
			focusEmail(){
				this.$refs.email.focus()
			},
			closeModal(event){
				this.email = ""
				this.validateLoginOnChange =  false
				this.generalLoginErrorMessage =  ""
				this.generalLoginErrorExist =  false
				this.userEmailErrorMessage =  ""
				this.userEmailErrorExist =  false
				this.loadingLogin = false
				this.showSuccess = false
				this.$root.$emit('bv::hide::modal','forgot-password-modal')
			},
			finishModal(){
				this.$refs.forgotPasswordModal.hide()
			},
			validResetPasswordForm(){
				this.generalLoginErrorMessage = ''
				this.generalLoginErrorExist = false

				if(this.validateLoginOnChange){
					if (!this.email || this.email.trim() == ""){
						this.userEmailErrorExist = true
						this.userEmailErrorMessage = 'Required'
					}else{
						this.userEmailErrorExist = false
						this.userEmailErrorMessage = ''
					}

					if (this.userEmailErrorExist){
						return false
					}
				}
				return true
			},

			async forgotPassword(){
				this.validateLoginOnChange = true
				if (this.validResetPasswordForm() && !this.loadingLogin){
					this.loadingLogin = true
					const url = `${this.$store.state.config.sfcHost}/reset_password/index.php`
					const params = {
						email: this.email,
						mode: "send_key",
						via: "ajax",
						from_app: "spa_nuxt"
					}
					const response = await this.$httpService.post(url, params)
					if (!response.success){
						this.generalLoginErrorMessage = `<span>${response.error}</span>`
						this.generalLoginErrorExist = true
					}else{
						this.showSuccess = true
					}
					this.loadingLogin = false
				}
			},
		}

	}
</script>
